import {useLocation} from "react-router-dom";
import {Box, Flex, Image, Text, useMediaQuery, Stack, VisuallyHidden} from "@chakra-ui/react";
import {routes} from "../../helper/constants";
import {getToken, withTokenParam} from "../../shared/session";
import {APPS, shortcutApps} from "../../helper/recentApps";
import NavItem from "../../components/navbar/NavItem";
import {scrollbar} from "../../components/styling";
import {useNav} from "../../context";
const padding = {base: "16px", md: "24px"};

function SidebarTitle() {
    return <Flex gap={".5rem"} py={8} px={padding} color="primary.500" textTransform="capitalize" fontWeight="bold" align="center">
        <svg width="43" height="44" aria-hidden="true">
            <use xlinkHref="#warehouse" />
        </svg>
        <Text>Resolve</Text>
        <VisuallyHidden as="h1">Resolve</VisuallyHidden>
    </Flex>;
}

function Sidebar() {
    const router = useLocation();
    const [isLargeScreen] = useMediaQuery(`(min-width: 768px)`);
    const nav = useNav();
    return <Stack
            flexDirection={"column"}
            justifyContent={"space-between"}
            w={{base: "100%", md: "310px"}}
            h={"100dvb"}
            pt={{base: "32px"}}
            pb={{base: "16px"}}
            boxShadow={"0px 2px 8px -1px rgba(27, 36, 44, 0.12)"}
        >
        <SidebarTitle/>
        <Flex mt={"24px"} gap="8px" flexDir="column" flex={"2 1 auto"} overflowY="auto" px={padding} sx={isLargeScreen ? scrollbar.styled : scrollbar.hidden}>
            {routes.map((props, i) => (
                <NavItem
                    key={i + 1}
                    {...props}
                    active={router.pathname.includes(props.href)}
                    onClose={nav.onClose}
                />
            ))}
        </Flex>
        <Text
            color={"primary.900"}
            fontWeight={500}
            fontSize={"12px"}
            lineHeight={"18px"}
            py={2.5}
            px={padding}
        >
            Shortcuts
        </Text>
        <Flex gap={"16px"} w={"100%"} px={padding}>
            {/* Home, then the two apps opened most recently (helper/recentApps) */}
            {shortcutApps().map(app => <Box
                key={app.key}
                w={"72px"}
                h={"72px"}
                borderRadius={"12px"}
                bg={"#fff"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                boxShadow={"0px 4px 13px 0px #0000000F"}
                title={APPS[app.key].name}
            >
                <Image
                    src={APPS[app.key].icon}
                    alt={APPS[app.key].name}
                    data-cy={`shortcut-${app.key}`}
                    w={"40px"}
                    h={"40px"}
                    onClick={() => {
                        // hands the session to the other app
                        window.open(
                            withTokenParam(app.url, getToken() ?? ""),
                            "_self"
                        );
                    }}
                    cursor={"pointer"}
                />
            </Box>)}
        </Flex>
    </Stack>;
}

export default Sidebar;
